export interface Keys {
	isTab: boolean;
	isShiftTab: boolean;
	isUp: boolean;
	isDown: boolean;
	isLeft: boolean;
	isRight: boolean;
	isEnter: boolean;
	isEscape: boolean;
	isSpace: boolean;
	isHome: boolean;
	isEnd: boolean;
}

interface GetKeysProps {
	code: string;
	shiftKey: boolean;
	metaKey: boolean;
}

interface GetIsNewTabProps {
	metaKey: boolean;
	ctrlKey: boolean;
}

export const getIsNewTab = (props: GetIsNewTabProps): boolean => {
	const isMac = navigator.userAgent.toUpperCase().indexOf('MAC') >= 0;

	return (isMac && props.metaKey) || (!isMac && props.ctrlKey);
};

export const getKeys = (event: GetKeysProps): Keys => ({
	isTab: event.code === 'Tab' && !event.shiftKey,
	isShiftTab: event.code === 'Tab' && event.shiftKey,
	isUp: event.code === 'ArrowUp',
	isDown: event.code === 'ArrowDown',
	isRight: event.code === 'ArrowRight',
	isLeft: event.code === 'ArrowLeft',
	isEnter: event.code === 'Enter' || event.code === 'NumpadEnter',
	isEscape: event.code === 'Escape',
	isSpace: event.code === 'Space',
	isHome:
		// windows home button
		event.code === 'Home' ||
		// mac alternative of home button
		(event.code === 'ArrowLeft' && event.metaKey),
	isEnd:
		// windows end button
		event.code === 'End' ||
		// mac alternative of end button
		(event.code === 'ArrowRight' && event.metaKey),
});
